import { EThemesEnum } from '@enum';

export interface Theme {
  Main: string;
  Secondary: string;

  Text: string;
  Title: string;
  Highlight: string;
  Background: string;
  BlockShadow: string;
  ElementShadow: string;

  TitleReverse: string;
  TitleReverse02: string;
  BackgroundReverse: string;
}

type ColorType = {
  [key in EThemesEnum]: Theme;
};

export const colors: ColorType = {
  [EThemesEnum.light]: {
    Main: '#805a3c',
    Secondary: '#3c6280',

    Text: '#00003f',
    Title: '#00003f',
    Highlight: 'rgba(60, 98, 128, 0.2)',
    Background: '#FFFFFF',
    BlockShadow: 'rgba(34, 60, 80, 0.2)',
    ElementShadow: 'rgba(0, 0, 63, 0.3)',

    BackgroundReverse: 'rgba(60, 98, 128, 0.2)',
    TitleReverse: '#00003f',
    TitleReverse02: '#FFFFFF',
  },
  [EThemesEnum.dark]: {
    Main: '#805a3c',
    Secondary: '#E6D9CA',

    Text: '#E6D9CA',
    Title: '#E6D9CA',
    Highlight: 'rgba(230, 217, 202, 0.2)',
    Background: '#2B2A33',
    BlockShadow: '#000000',
    ElementShadow: '#000000',

    BackgroundReverse: '#E6D9CA',
    TitleReverse: '#00003f',
    TitleReverse02: '#00003f',
  },
};

export const getTheme = (theme: EThemesEnum) => colors[theme];
